import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function AdminPolicies() {
  const [policies, setPolicies] = useState([]);
  const [working, setWorking] = useState(null);

  const refresh = () => api.get("/policies").then(({ data }) => {
    setPolicies(data);
    if (data[0]) setWorking({ ...data[0] });
  });
  useEffect(() => { refresh(); }, []);

  const save = async () => {
    try {
      await api.put(`/policies/${working.id}`, {
        priority_pricing: working.priority_pricing,
        active: working.active,
        name: working.name,
        scope: working.scope,
      });
      toast.success("Policy updated");
      refresh();
    } catch (e) {
      toast.error("Save failed");
    }
  };

  if (!working) return <div className="p-8 text-zinc-500 font-mono text-xs">LOADING…</div>;

  return (
    <div className="p-6 lg:p-8 max-w-3xl">
      <div className="mb-6">
        <div className="bin-label">RULES</div>
        <h1 className="text-3xl font-black tracking-tighter mt-1">Pricing Policy</h1>
      </div>

      <div className="bin-card p-6">
        <div className="bin-label mb-3">{working.name} · {working.scope}</div>
        <div className="space-y-3">
          {Object.entries(working.priority_pricing).map(([k, v]) => (
            <div key={k} className="flex items-center gap-3">
              <label className="bin-label flex-1">{k.replace("_", " ")}</label>
              <span className="text-zinc-500 font-mono text-xs">$/kWh</span>
              <input
                data-testid={`policy-${k}`}
                type="number"
                step="0.01"
                value={v}
                onChange={(e) => setWorking({
                  ...working,
                  priority_pricing: { ...working.priority_pricing, [k]: Number(e.target.value) },
                })}
                className="w-32 bg-[#18181b] border border-zinc-800 rounded px-3 py-1.5 text-sm font-mono"
              />
            </div>
          ))}
        </div>
        <button data-testid="save-policy" onClick={save} className="bin-btn bin-btn-primary mt-6">Save policy</button>
      </div>
    </div>
  );
}
